(function() {
    'use strict';

    angular
        .module('agentApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL', '$base64', '$urlRouterProvider'];

    function stateConfig($stateProvider,GLOBAL_URL,$base64, $urlRouterProvider) {
    	$urlRouterProvider.otherwise("/agent-info");
        $stateProvider.state('agent-info', {
            url: '/agent-info/:txnId',
            data: {
                pageTitle: 'HỒ SƠ ỨNG VIÊN ĐẠI LÝ'
            },
            params: { txnId: {squash: true, value: null }},
            views : {
				'content@' : {
					templateUrl : GLOBAL_URL+'partial?uri=ga/agent-info/agent-info',
					controller: 'AgentInfoController',
					controllerAs:'agentInfoCtr'
				}
			},
			resolve : {
				 entity: function(AgentInfoService, $stateParams){	
		    			if($stateParams.txnId != null && $stateParams.txnId != undefined){
		    				var agentInfo =  AgentInfoService.get({uri:"get-agent-info", txnId:$base64.decode($stateParams.txnId)}).$promise;
		    				return agentInfo;
		    			}else{
		    				return null;
		    			}
		    		}
			}
        })
    }
})();
